module.exports = __webpack_public_path__ + "static/media/Ledyba_gaussian2.3f4baf0c.png";